import React, { useState } from 'react';
import { Route, Routes } from 'react-router';
import { Grid } from '@mui/joy';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';
import Home from './Home';
import ChatbotDocs from './Docs';
import './dashboard.css';
import Questions from './Questions';
import AiJobDesc from './AI-AssistedJobDescription/AiJobDesc';
import JobDescription from './JobDescription';
import AI_Add_Resume from './AI_AssistedResumeBuilder/AI_Add_Resume';
import DragSwapBoxes from './AI_AssistedResumeBuilder/AI_Assisted_Resume_Builder_usingdnd';
import { Maximize } from '@mui/icons-material';

export default function Dashboard() {
  const [selected, setSelected] = useState('home');
  return (
    <Grid container spacing={0}>
      <Grid
        item
        xs={12}
        md={12}
        container
        // sx={{ backgroundColor: '#292929', borderBottom: '1px solid #ddd', borderRadius: '35px' }}
        sx={{ backgroundColor: '#292929', borderRadius: '35px' }}
        // spacing={1}
      >
        <header className="chatbot-header">
          <nav className="nav">
            <ul className="nav-list">
              <li
                className="nav-item"
                style={{ color: '#008559' }}
                onClick={() => {
                  setSelected('home');
                }}
              >
                <Link to="/aichatbot/dashboard" className="nav-link">
                  Home
                </Link>
              </li>
              <li
                className="nav-item"
                style={{ color: selected == 'docs' ? '#008559' : '' }}
                onClick={() => {
                  setSelected('docs');
                }}
              >
                <Link to="/aichatbot/dashboard/docs" className="nav-link">
                  Docs
                </Link>
              </li>
            </ul>
          </nav>
        </header>
      </Grid>
    </Grid>
  );
}
